import { Link, useLocation } from "react-router-dom";
import {
  FiHome,
  FiSettings,
  FiEdit3,
  FiImage,
  FiMail,
  FiKey,
  FiCreditCard,
  FiEye,
  FiDatabase,
  FiZap,
  FiChevronsLeft,
  FiChevronsRight,
  FiArrowUpRight,
} from "react-icons/fi";
import { getCurSiteId } from "../lib/Common_funcs";

const navItems = [
  { path: "/home",            label: "Overview",      icon: FiHome },
  { path: "/sites",           label: "Site Settings", icon: FiSettings },
  { path: "/editor",          label: "Site Editor",   icon: FiEdit3 },
  { path: "/asset-libraries", label: "Assets",        icon: FiImage },
  { path: "/contactforms",    label: "Contact Forms", icon: FiMail },
  { path: "/authkeys",        label: "API Keys",      icon: FiKey },
  { path: "/subscription",    label: "Subscription",  icon: FiCreditCard },
  { path: "/site-preview",    label: "Preview",       icon: FiEye },
  { path: "/automations",     label: "Automations",   icon: FiZap },
];

const StDashSidebar = ({ collapsed, onToggle }) => {
  const location = useLocation();
  const curSiteId = getCurSiteId();

  const isActive = (path) => location.pathname.includes(path);

  if (collapsed) {
    return (
      <aside
        className="app-sidebar"
        style={{ width: "56px", minWidth: "56px", padding: "12px 8px", transition: "width 200ms ease" }}
      >
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "16px" }}>
          <Link to={`/${curSiteId}/home`}>
            <img src="/turbo-navbar-logo.png" alt="TurboSteed" style={{ height: "26px", width: "auto", display: "block" }} />
          </Link>
        </div>

        <nav style={{ flex: 1 }}>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "4px" }}>
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={`/${curSiteId}${item.path}`}
                  title={item.label}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "40px",
                    height: "40px",
                    borderRadius: "var(--radius-md)",
                    color: isActive(item.path) ? "var(--accent-primary)" : "var(--text-tertiary)",
                    background: isActive(item.path) ? "var(--accent-soft)" : "transparent",
                    transition: "all 100ms ease",
                    textDecoration: "none",
                  }}
                >
                  <item.icon size={18} />
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <button
          onClick={onToggle}
          title="Expand sidebar"
          style={{
            display: "flex", alignItems: "center", justifyContent: "center",
            width: "40px", height: "40px", border: "none",
            borderRadius: "var(--radius-md)", background: "var(--bg-tertiary)",
            color: "var(--text-tertiary)", cursor: "pointer", marginTop: "auto",
          }}
        >
          <FiChevronsRight size={16} />
        </button>
      </aside>
    );
  }

  return (
    <aside className="app-sidebar" style={{ transition: "width 200ms ease" }}>
      <div className="sidebar-brand" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Link to={`/${curSiteId}/home`} className="sidebar-brand-link">
          <img src="/turbo-navbar-logo.png" alt="TurboSteed" className="sidebar-brand-logo" />
          <span className="sidebar-brand-text">TurboSteed</span>
        </Link>
        {onToggle && (
          <button
            onClick={onToggle}
            title="Collapse sidebar"
            style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              width: "28px", height: "28px", border: "none",
              borderRadius: "var(--radius-sm)", background: "transparent",
              color: "var(--text-tertiary)", cursor: "pointer",
              opacity: 0.6, transition: "opacity 100ms ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.6")}
          >
            <FiChevronsLeft size={16} />
          </button>
        )}
      </div>

      <nav className="sidebar-nav">
        <ul className="sidebar-nav-list">
          {navItems.map((item) => (
            <li key={item.path} className="sidebar-nav-item">
              <Link
                to={`/${curSiteId}${item.path}`}
                className={`sidebar-nav-link${isActive(item.path) ? " active" : ""}`}
              >
                <item.icon />
                {item.label}
              </Link>
            </li>
          ))}
          <li className="sidebar-nav-item">
            <Link
              to={`/${curSiteId}/cms`}
              className={`sidebar-nav-link${isActive("/cms") ? " active" : ""}`}
              style={{ justifyContent: "flex-start" }}
            >
              <FiDatabase />
              CMS
              <FiArrowUpRight size={12} style={{ marginLeft: "auto", opacity: 0.4 }} />
            </Link>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default StDashSidebar;
